var map = {
	"./qilin-stage1-hungry.png": "9bbe",
	"./qilin-stage2-hungry.png": "8d6d",
	"./qilin-stage3-hungry.png": "a84b",
	"./qilin-stage4-hungry.png": "6580",
	"./qilin-stage5-hungry.png": "e362",
	"./qilin-stage6-hungry.png": "f08e",
	"./qilin-stage7-hungry.png": "baba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e2e";